module.exports = __webpack_public_path__ + "static/img/icon_empty.22af1093.png";